import React from "react";
import "./AnalyticsHero.css";

const AnalyticsHero = () => {
  return (
    <section className="analytics-hero">
      <div className="analytics-hero__content">
        <h1 className="analytics-hero__title">Main Title Placeholder</h1>

        <p className="analytics-hero__subtitle">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.
        </p>

        <div className="analytics-hero__actions">
          <button className="btn btn-primary">
            Start with Lorem ipsum
          </button>

          <button className="btn btn-outline">Discover the Platform</button>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsHero;
